import { mdiFilterCheckOutline } from '@mdi/js'

export default {
  title: 'Bank Category',
  icon: mdiFilterCheckOutline,
  to: 'bank-category',
  resource: 'BankCategoryAdmin',
  action: 'read',
}
